import styled from 'styled-components';

export const ProductSubRequests = styled.div`
  .user-name {
    align-self: center;
  }
  .toggle-group {
    margin-left: auto;
  }
  .user-row {
    max-width: 30em;
    margin-left: 2em;
  }
  .unsub {
    margin-top: 2em;
  }
`;
